import type {ReferenceType} from '../attachments/attachment-refs'
import {createContext, type MutableRefObject} from 'react'

export interface ReferenceAttachParams {
  referenceType: ReferenceType
  number: number
  url: string
  title?: string
  state?: string
}

export type ReferenceAttachHandler = (params: ReferenceAttachParams | null) => void

export interface ReferenceAttachRegistry extends MutableRefObject<ReferenceAttachHandler | null> {
  subscribe?: (listener: () => void) => () => void
}

export function createReferenceAttachRegistry(): ReferenceAttachRegistry {
  let current: ReferenceAttachHandler | null = null
  const listeners = new Set<() => void>()

  return {
    get current() {
      return current
    },
    set current(value) {
      current = value
      for (const listener of listeners) listener()
    },
    subscribe(listener) {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
  }
}

/**
 * Holds the active writable composer's workbench-reference sync handler and can
 * notify subscribers when registration changes. Plain mutable refs remain valid
 * context values. Read-only and blocked composers do not register.
 */
export const ReferenceAttachContext = createContext<ReferenceAttachRegistry | null>(null)
